/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import {jsx, css} from '@emotion/core'
import { Fields, arrayInsert, arrayRemove, mediaQueries, Disclosures } from '../../../twd/twd'
import useScatterGraph from '../use-scatter-graph'

export default () => {
    const {
        benchmarks,
        selectedBenchmarks,
        setSelectedBenchmarks,
        colors
    } = useScatterGraph()

    return <React.Fragment>
    <div className="row vertical-offset-sm">
    <div className="col-md-1"></div>
    <div className="col-md-9 col-xs-12 text-center">
        <div css={legendCss}>
            <label className="text-small">Yield curves: &nbsp;&nbsp;</label>
        </div>
        {
            benchmarks.map((a, index) =>
                <div css={legendCss} key={index}>
                <Fields.CheckboxLabel
                dataName="corporates-scatter-graph-benchmark"
                key={index}
                value={a}
                label={a}
                checked={selectedBenchmarks.indexOf(a)>=0}

                onChange={(e) => {
                    let v = e.target.value
                    let f = e.target.checked
                    let a = [...selectedBenchmarks]
                    let n = f ? arrayInsert(a, v) : arrayRemove(a,v)
                    setSelectedBenchmarks(n)
                }}

                className="label-small"
                style={{
                    borderLeft:'4px solid ' + colors[index],
                    paddingLeft:'5px',
                    paddingRight:'10px',
                }} />
                </div>
            )
        }
    </div>
    <div className="col-xs-12 col-md-2 text-right">
        <Disclosures
            dataName='corporates-scatter-graph-disclosures-link'
            html={DISCLOSURES} />
    </div>
    </div>
    </React.Fragment>
}

const legendCss = css`
    ${mediaQueries.notXs} {
        display: inline-block;
    }
    ${mediaQueries.xs} {
        text-align:left;
        width: 100%;
        display: block;
        padding: 1px 0;
        margin-bottom: 5px;
    }
`

let DISCLOSURES = `
    <p>
    This graph allows you to see whether a bond is yielding more or less than
    the prevailing yields for comparable bonds. By default, the scatter graph
    will plot offerings from the top five most heavily traded issuers currently
    available on the Bond Resource Center. Each bond is depicted as
    an individual point on the graph, and each issuer has a defined color designation.
    The chart also displays color-coded Treasury and corporate yield curves
    to analyze against the plotted offerings.
    </p>
    <p>
    To amend the issuers displayed in your scatter graph view, click the
    “Top 5 actively traded issuers” dropdown and use the checkboxes to alter
    your active selections. Additionally, you may conduct a separate custom search
    by entering a company name or symbol in the “Custom issuer” search bar.
    Users can also customize the active yield curves by interacting with
    the yield curve checkboxes at the base of the graph.
    </p>`



// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/benchmark/legends.js